<template>
  <div class="radar-buy">
    <div class="language-switcher">
      <router-link :to="{ path: '/' }" class="lang-link" :class="{ active: $route.path === '/' }">RU</router-link>
      <span class="lang-separator">|</span>
      <router-link :to="{ path: '/en' }" class="lang-link" :class="{ active: $route.path === '/en' }">EN</router-link>
    </div>
    <div>
      <div class="title">
        <h1>{{ t.title }}</h1>
      </div>
      <div class="description">
        <h2>
          {{ t.description.main }}
          <br /><span class="demo-text"
            ><b>{{ t.description.demo }}</b></span
          >
          {{ t.description.demoNote }}
        </h2>
        <p>
          {{ t.description.features }}
          <b class="demo-text">{{ t.description.purpose }}</b
          ><br />
          <br />
          {{ t.description.instructions }}<br />
          {{ t.description.subscription }} <b>{{ t.description.hardware }}</b>
        </p>
      </div>
      <div class="btn-section">
        <div>
          <Button :text="t.buttons.download" @click="checkBeforeDownload" />
        </div>
        <router-link :title="t.buttons.subscription" to="/en/buykey">
          <Button :text="t.buttons.subscription" />
        </router-link>
      </div>
      <div class="demo-text navigation">
        <a href="#guide" :title="t.navigation.howToLaunch">{{ t.navigation.howToLaunch }}</a>
        <router-link :to="{ name: 'FaqEn' }" :title="t.navigation.errors">{{ t.navigation.errors }}</router-link>
      </div>
    </div>

    <div style="display: flex; justify-content: center">
      <video width="100%" height="auto" controls>
        <source src="@/assets/video/demo_video.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="section advertisers">
      <h2>{{ t.advantages.title }}</h2>
      <ul>
        <li v-for="(item, index) in t.advantages.items" :key="index">{{ item }}</li>
      </ul>
    </div>
    <div class="section guide">
      <h2 id="guide">{{ t.guide.title }}</h2>
      <video width="100%" height="auto" controls>
        <source src="@/assets/video/guide_en.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <br /><br />
      <p><b>*Tested on Windows 10/11</b></p>
      <p>
        {{ t.guide.steps.step1 }} <a @click="checkBeforeDownload" title="Download cssoftshop updater"><b>updater</b></a> {{ t.guide.steps.step2 }}
        {{ t.guide.steps.step3 }}
        <b>{{ t.guide.steps.antivirus }}</b
        ><br /><br />
        {{ t.guide.steps.settings }}
      </p>
      <div style="margin-top: 10px; text-align: center">
        <img class="gui_example" alt="CS2 WH cheat and its interface" title="Cheat interface" src="../assets/img/cs2_cheat_v_3_0.png" />
      </div>
      <p>{{ t.guide.steps.step4 }}</p>
      <div style="margin-top: 10px; text-align: center">
        <img class="esp_example" alt="CS2 WH example - HP level highlight" title="CS2 WH example - HP level highlight" src="../assets/img/cs2_esp.png" />
      </div>
      <div style="margin-top: 10px; text-align: center">
        <img class="esp_example" alt="CS2 WH example" title="CS2 WH example" src="../assets/img/cs2_esp settings.png" />
      </div>
      <p>{{ t.guide.steps.note }}</p>
      <p>
        <b>{{ t.guide.steps.important }}</b
        ><br />
        {{ t.guide.steps.update }}
      </p>
      <p>
        {{ t.guide.steps.support }}
        <a target="_blank" href="https://vk.com/cssoftshop" title="VK Group">VK group</a>
      </p>
    </div>
    <el-dialog
      :visible.sync="centerDialogVisible"
      :title="t.agreement.title"
      append-to-body
      :lock-scroll="false"
      :destroy-on-close="true"
      class="window-style"
      @closed="downloadWindowClosed"
      center
    >
      <p class="demo-text" style="word-break: break-word">
        {{ t.agreement.text }} <a target="_blank" style="color: white" href="https://cssoftshop.app/terms">{{ t.agreement.terms }}</a> <br /><br />
        {{ t.agreement.share }}<br /><br />
        {{ t.agreement.libraries }}<br /><br />
        {{ t.agreement.installer }}
      </p>
      <br />
      <el-checkbox v-model="iAgree" class="agree_checkbox">{{ t.agreement.checkboxes.agree }}</el-checkbox
      ><br />
      <el-checkbox v-model="iAgree2" class="agree_checkbox">{{ t.agreement.checkboxes.libraries }}</el-checkbox>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!iAgree || !iAgree2" type="success" :disabled="true">{{ t.agreement.download }}</el-button>
        <a v-else href="https://cloudcss.ru" target="_blank">
          <el-button type="success" :disabled="!iAgree || !iAgree2">{{ t.agreement.download }}</el-button>
        </a>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Button from '@/components/Button.vue';
import { isDeprecatedWindows } from '@/utils/utils';

export default {
  name: 'HomeEn',
  components: {
    Button,
  },
  metaInfo() {
    const baseUrl = 'https://cssoftshop.app';
    return {
      title: 'Download cssoftshop loader for CS2',
      meta: [{ name: 'description', content: 'CS2 Wallhack (WH). Easy to use, VAC undetectable.' }],
      link: [
        { rel: 'canonical', href: `${baseUrl}/en` },
        { rel: 'alternate', hreflang: 'ru', href: baseUrl },
        { rel: 'alternate', hreflang: 'en', href: `${baseUrl}/en` },
        { rel: 'alternate', hreflang: 'x-default', href: baseUrl },
      ],
    };
  },
  data() {
    return {
      centerDialogVisible: false,
      isDownloading: false,
      iAgree: false,
      iAgree2: false,
      t: {
        title: 'CS2 Wallhack / WH for CS2',
        description: {
          main: 'Here you can download CS2 wallhack for free without registration!',
          demo: '1 day demo period for new users',
          demoNote: '(demo period may be disabled on weekends)',
          features: 'Our cheat (WH) contains only the most necessary functionality and does not use overlays.',
          purpose: 'Designed for training games with computer opponents (bots).',
          instructions: 'Please read the installation and launch instructions carefully.',
          subscription: 'After the demo period ends, you can choose a subscription option that suits you.',
          hardware: 'Subscription is tied to PC hardware.',
        },
        buttons: {
          download: 'DOWNLOAD CS2 WH (loader)',
          subscription: 'SUBSCRIPTION',
        },
        navigation: {
          howToLaunch: 'How to launch',
          errors: 'Launch errors',
        },
        advantages: {
          title: 'OUR ADVANTAGES:',
          items: [
            'No registration required',
            'No need to install any programs. Just download the .exe file in the archive',
            "You don't need to download or update the client after CS updates",
            'We use only the most necessary functionality that will help you train with bots',
            "We don't use overlays, which positively affects performance",
            'Timely updates and support for the current version of CS',
            'Wide range of subscription options',
          ],
        },
        guide: {
          title: 'HOW TO LAUNCH WH:',
          steps: {
            step1: 'Move the downloaded file',
            step2: 'to the folder where you want to install the program and run it.',
            step3: 'The updater will automatically download the necessary files.',
            antivirus: '(Antivirus may interfere with downloading files or delete some, be careful!)',
            settings: 'In game settings (VIDEO ↓ GRAPHICS) set "FULLSCREEN WINDOWED" or "WINDOWED"',
            step4: 'Create and launch a game with bots and after loading click "Enable"',
            note: 'After that, you can turn WH on and off at any time (without restarting CS)',
            important: 'Important: if the cheat is enabled but no effect is observed, CS may have been updated.',
            update: 'You need to wait until we update our server and run the cheat again. Enjoy the game :)',
            support: 'You can check for updates or ask a question to technical support in',
          },
        },
        agreement: {
          title: 'Agreement',
          text: 'The program is intended exclusively for training games with computer opponents (bots). '
            + 'By using it, you agree to this condition and confirm that you have read and accept the',
          terms: 'Terms of Use',
          share: 'When sharing the program with others, you must familiarize them with the terms of use.',
          libraries: 'The program may use third-party libraries (e.g. RestSharp)',
          installer: 'The program is installed using a loader-updater. It is also used for program updates.',
          checkboxes: {
            agree: 'I have read and agree to the terms of use',
            libraries: 'I agree to install the loader and third-party libraries',
          },
          download: 'Download loader',
        },
      },
    };
  },
  methods: {
    checkBeforeDownload() {
      if (false && isDeprecatedWindows()) {
        this.$notify.error({
          title: 'Error',
          message: 'Windows 10 or higher is required for the program to work correctly',
        });
      } else {
        this.centerDialogVisible = true;
      }
    },
    downloadWindowClosed() {
      this.iAgree = false;
      this.iAgree2 = false;
    },
  },
};
</script>

<style scoped lang="sass">
a
  cursor: pointer

.radar-buy
  text-align: left
  max-width: 900px
  .title
    text-align: center
    margin-bottom: 20px
.btn-section
  margin: 30px 0px 30px 0px
  display: flex
  justify-content: space-evenly
  flex-wrap: wrap
  gap: 10px
.demo-text
  color: #ff6130
  a
    color: #ff6130

.esp_example
  width: 450px
  max-width: 100%

.gui_example
  width: 296px

.image-caption
  font-size: 12px

.advertisers
  color: white
  li
    margin-left: 30px
    color: white
    font-size: 18px
    line-height: 1.5
    &::marker
      content: '👍 '

/deep/ .el-dialog
  background-color: #1e1e1e
  border-radius: 10px
/deep/ .el-dialog__title
  color: white

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner
    background-color: #67C23A
    border-color: #67C23A

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label
  color: #67C23A

/deep/ .el-icon-close
  &:hover
    color: #ff8000

.agree_checkbox
  display: flex
  align-items: center
  /deep/ .el-checkbox__label
    white-space: normal

.navigation
  font-size: 18px
  font-weight: bold
  margin-bottom: 30px
  display: flex
  justify-content: center
  flex-wrap: wrap
  align-content: space-between
  gap: 10px

.window-style
  max-width: 100%
  /deep/ .el-dialog
    max-width: 600px
    width: 90%
    min-width: 320px

.language-switcher
  position: absolute
  top: 20px
  right: 20px
  font-size: 16px
  font-weight: bold

  .lang-link
    color: #666
    text-decoration: none
    transition: color 0.3s ease

    &:hover
      color: #ff6130

    &.active
      color: #ff6130

  .lang-separator
    margin: 0 10px
    color: #666
</style>
